import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-black text-white py-12 border-t border-gray-800" data-id="element-69">
      <div className="container mx-auto px-4" data-id="element-70">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12" data-id="element-71">
          <div data-id="element-72">
            <Link to="/" className="text-2xl font-bold block mb-4" data-id="element-73">
              IKHAN<span className="text-red-600" data-id="element-74">FX</span>
            </Link>
            <p className="text-gray-400 mb-4" data-id="element-75">
              Premium trading education from industry experts to help you master
              the markets.
            </p>
          </div>
          <div data-id="element-76">
            <h4 className="font-bold text-lg mb-4" data-id="element-77">Classes</h4>
            <ul className="space-y-2" data-id="element-78">
              <li data-id="element-79">
                <Link to="/classes/category/forex-fundamentals" className="text-gray-400 hover:text-white transition-colors" data-id="element-80">
                  Forex Fundamentals
                </Link>
              </li>
              <li data-id="element-81">
                <Link to="/classes/category/technical-analysis" className="text-gray-400 hover:text-white transition-colors" data-id="element-82">
                  Technical Analysis
                </Link>
              </li>
              <li data-id="element-83">
                <Link to="/classes/category/risk-management" className="text-gray-400 hover:text-white transition-colors" data-id="element-84">
                  Risk Management
                </Link>
              </li>
              <li data-id="element-85">
                <Link to="/classes/category/trading-psychology" className="text-gray-400 hover:text-white transition-colors" data-id="element-86">
                  Trading Psychology
                </Link>
              </li>
              <li data-id="element-87">
                <Link to="/classes/category/cryptocurrency-trading" className="text-gray-400 hover:text-white transition-colors" data-id="element-88">
                  Cryptocurrency
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-89">
            <h4 className="font-bold text-lg mb-4" data-id="element-90">Company</h4>
            <ul className="space-y-2" data-id="element-91">
              <li data-id="element-92">
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors" data-id="element-93">
                  About Us
                </Link>
              </li>
              <li data-id="element-94">
                <Link to="/careers" className="text-gray-400 hover:text-white transition-colors" data-id="element-95">
                  Careers
                </Link>
              </li>
              <li data-id="element-96">
                <Link to="/press" className="text-gray-400 hover:text-white transition-colors" data-id="element-97">
                  Press
                </Link>
              </li>
              <li data-id="element-98">
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors" data-id="element-99">
                  Contact
                </Link>
              </li>
              <li data-id="element-100">
                <Link to="/gift" className="text-gray-400 hover:text-white transition-colors" data-id="element-101">
                  Gift Membership
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-102">
            <h4 className="font-bold text-lg mb-4" data-id="element-103">Support</h4>
            <ul className="space-y-2" data-id="element-104">
              <li data-id="element-105">
                <Link to="/help" className="text-gray-400 hover:text-white transition-colors" data-id="element-106">
                  Help Center
                </Link>
              </li>
              <li data-id="element-107">
                <Link to="/terms" className="text-gray-400 hover:text-white transition-colors" data-id="element-108">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-109">
                <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors" data-id="element-110">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-111">
                <Link to="/accessibility" className="text-gray-400 hover:text-white transition-colors" data-id="element-112">
                  Accessibility
                </Link>
              </li>
              <li data-id="element-113">
                <Link to="/cookies" className="text-gray-400 hover:text-white transition-colors" data-id="element-114">
                  Cookie Preferences
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center" data-id="element-115">
          <p className="text-gray-400 text-sm mb-4 md:mb-0" data-id="element-116">
            © {new Date().getFullYear()} IKHAN
            <span className="text-red-600" data-id="element-117">FX</span>. All rights reserved.
          </p>
          <div className="flex space-x-6" data-id="element-118">
            <a href="#" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-119">
              <span className="sr-only" data-id="element-120">Facebook</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-121">
                <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" data-id="element-122" />
              </svg>
            </a>
            <a href="#" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-123">
              <span className="sr-only" data-id="element-124">Instagram</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-125">
                <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" data-id="element-126" />
              </svg>
            </a>
            <a href="#" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-127">
              <span className="sr-only" data-id="element-128">Twitter</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-129">
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-130" />
              </svg>
            </a>
            <a href="#" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-131">
              <span className="sr-only" data-id="element-132">YouTube</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-133">
                <path fillRule="evenodd" d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z" clipRule="evenodd" data-id="element-134" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>;
}